import { Alert as BSAlert } from 'react-bootstrap';
import type { ReactChild, ReactFragment } from 'react';

import type { AlertKind } from './alert-constants';

type AlertProps = {
  /**
   * the kind of alert to display, which dictates the color of the alert banner
   */
  kind: AlertKind;
  /**
   * Header to display in the Alert, can be a React Node or string
   */
  header: ReactFragment | ReactChild | string;
  /**
   * Body of the Alert
   */
  children: ReactChild;
};

/**
 * A Generic Alert that wraps the react-bootstrap Alert
 */
const Alert = ({ kind, header, children }: AlertProps) => (
  <BSAlert bsStyle={kind} style={{ padding: '20px' }}>
    <h3 style={{ display: 'inline', color: 'inherit' }}>{header}</h3>
    <div style={{ margin: '10px 20px', fontSize: '16px' }}>{children}</div>
  </BSAlert>
);

export default Alert;
